import React, { useState } from "react";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";

import logoradien from "../../../assets/raiden-logos.png";
import whatsApp from '../../../assets/Mobile-app/whatsapp.svg'
import contact from '../../../assets/Mobile-app/contact.svg'
import { FaWhatsapp, FaPhone,FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

import {
  ProSidebar,
  SidebarHeader,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
  SidebarFooter,
} from "react-pro-sidebar";

const HomeMobileMenu = [
  {
    name: "Event Organiser",
    routerPath: "/",
  },
  {
    name: "Project Management",
    routerPath: "/project-management",
  },
  {
    name: "Customer Support",
    routerPath: "/customer-support",
  },
  {
    name: "Doc landing",
    routerPath: "/doc-landing",
  },
  {
    name: "Product landing",
    routerPath: "/product-landing",
  },
  {
    name: "Product landing Dark",
    routerPath: "/product-landing-dark",
  },
  {
    name: "Note Taking App landing",
    routerPath: "/note-taking-landing",
  },
  {
    name: "Video Editor Landing",
    routerPath: "/video-editor-landing",
  },
  {
    name: "Appointment Scheduling",
    routerPath: "/appointment-scheduling",
  },
  {
    name: "Mobile App",
    routerPath: "/mobile-app-landing",
  },
  {
    name: "Doc Signature",
    routerPath: "/doc-signature",
  },
  {
    name: "Website Builder",
    routerPath: "/website-builder",
  },
  {
    name: "Form Survey",
    routerPath: "/form-survey-landing",
  },
  {
    name: "VR Landing",
    routerPath: "/vr-landing",
  },
  {
    name: "E-Commerce",
    routerPath: "/e-commerce",
  },
  {
    name: "Coming Soon",
    routerPath: "/coming-soon",
  },
];

const CustomAppDev = [
  {
    name: "Mobile App Develop....",
    routerPath: "/mobile-app-development",
  },
  {
    name: "Iphone App  Develop.... ",
    routerPath: "/iphone-app-development",
  },
  {
    name: "Android app Develop....",
    routerPath: "/android-app-development",
  },
  {
    name: "Flutter App Develop....  ",
    routerPath: "/flutter-app-development ",
  },
  {
    name: "React Native App De.......  ",
    routerPath: "/react-native-development  ",
  },
  {
    name: " Wearable app Develop.... ",
    routerPath: "/wearable-development  ",
  },
  {
    name: "Hybrid Mobile App De........  ",
    routerPath: "/hybrid-development  ",
  },
  {
    name: "Mobile App Develop....  ",
    routerPath: "/mobile-app-developers  ",
  },
  {
    name: " Mobile App Mainten......  ",
    routerPath: "/app-maintenence-support  ",
  },
];
const WebDev = [
  {
    name: "UI and UX Design",
    routerPath: "/webdesign",
  },
  {
    name: "Website Development......",
    routerPath: "/web-development",
  },
  {
    name: "PHP Web Developmen...",
    routerPath: "/php-development",
  },
  {
    name: "Java Development",
    routerPath: "/java-development",
  },
  {
    name: "AngularJS Developm... ",
    routerPath: "/angular-develoment ",
  },
  {
    name: " Ruby App Developm...",
    routerPath: "/ruby-on-rails ",
  },
  {
    name: " E-Commerce Website.....",
    routerPath: "/ecommerce-web-development ",
  },
  {
    name: "Software Development ",
    routerPath: "/software-development ",
  },
];
const EmergingTech = [
 
  {
    name: "AR VR Development   ",
    routerPath: "/ar-vr-development",
  },
  {
    name: " AI ML Development ",
    routerPath: "/ai-ml-development ",
  },
  {
    name: " IoT Development  ",
    routerPath: "/iot-development ",
  },
  {
    name: "POS Software Develop...  ",
    routerPath: "/pos-software-development ",
  },
  {
    name: "Web3 software Develo.....  ",
    routerPath: "/web3-development ",
  },
];
const GameDev = [
  {
    name: "Poker Game Develop.... ",
    routerPath: "/poker-game-development ",
  },
  {
    name: " Ludo Game Develo....",
    routerPath: "/ludo-game-development",
  },
  {
    name: " AR Game Developm....",
    routerPath: "/ar-game-development ",
  },
  {
    name: "Casino Game Develop....",
    routerPath: "/casino-game-development",
  },
  {
    name: " VR Game Develop....",
    routerPath: "/vr-game-development",
  },
  {
    name: " Unreal Game Develop...",
    routerPath: "/unreal-engine-game-development",
  },
  {
    name: "Unity Game Develop.... ",
    routerPath: "/unity-game-development",
  },
  {
    name: " Rummy Development",
    routerPath: "/rummy-game-development ",
  },
  {
    name: "Arcade Game Develop..... ",
    routerPath: "/arcade-game-development ",
  },
  {
    name: "Bingo Game Develop.... ",
    routerPath: "/bingo-game-development",
  },
  
  {
    name: " Board Game Develop.....",
    routerPath: "/board-game-development ",
  },
];
const BlockChain = [
  {
    name: "BlockChain Game Dev.......... ",
    routerPath: "/blockchain-game-development ",
  },
  {
    name: "Blockchain app Devel...",
    routerPath: "/blockchain-app",
  },
]
const XR = [
  {
    name: "Raiden Verse ",
    routerPath: "/raiden-verse ",
  },
  {
    name: "Raiden Simx",
    routerPath: "/raiden-simx ",
  },
  {
    name: " Raiden COGNI+",
    routerPath: "/raiden-cogni  ",
  },
  {
    name: "Raiden ARCVIZ ",
    routerPath: "/raiden-arcviz",
  },
];

const Game = [
  {
    name: "Clash Empire ",
    routerPath: "/clash-empire ",
  },
  {
    name: "Virtual Vegas ",
    routerPath: "/virutal-vegas ",
  },
  {
    name: " Metaverse Royal",
    routerPath: "/metaverse-royal ",
  },
];
const Resources = [
  {
    name: "Blog",
    routerPath: "/blog",
  },
  {
    name: "Case Study",
    routerPath: "/case-study",
  },
];
const Company = [
  {
    name: "About Us",
    routerPath: "/about-us",
  },
  {
    name: "Career",
    routerPath: "/career",
  },
 
  

];

const MegaMenuMobile = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <div className="mega-menu-wrapper">
      <div className="mega-swicher"></div>
      <div className="mob-header multi-mob-header">
        <button className="toggler-menu" onClick={handleClick}>
          <div className={click ? "active" : ""}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>

      <ProSidebar
        className={click ? "mega-mobile-menu menu-open" : "mega-mobile-menu"}
      >
        
        <SidebarHeader>
          <div className="logo position-static">
            <a href="index.html">
              <img src={logoradien} alt="home-demo" />
            </a>
          </div>
          <div className="fix-icon text-dark" onClick={handleClick}>
            <img src="images/icon/close-w.svg" alt="icon" />
          </div>
 

          {/* End logo */}
        </SidebarHeader>
        <SidebarContent>
          <Menu>
            <MenuItem>
              <Link to="/">Home </Link>
            </MenuItem>

            <SubMenu title="Services">
              <SubMenu title="Custom App Development" className="plus alt">
                {CustomAppDev.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath} className="single">
                      {val.name}
                    </Link>
                  </MenuItem>
                ))}
              </SubMenu>

              <SubMenu title="Web Development" className="plus alt">
                {WebDev.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
              {/* End About SubMenu */}

              <SubMenu title="Emerging Technologies " className="plus alt">
                {EmergingTech.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
              {/* End Contact Us SubMenu */}

              <SubMenu title="Game Devlopment" className="plus alt">
                {GameDev.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
           
             <SubMenu title="Blockchain Development" className="plus alt">
                {BlockChain.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
            </SubMenu>
            

            <SubMenu title="Products">
              <SubMenu title="XR" className="plus alt">
                {XR.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
              <SubMenu title="Game" className="plus alt">
                {Game.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>
            </SubMenu>
            {/* End Feautres SubMenu */}

            <SubMenu title="Resources">
              {Resources.map((val, i) => (
                <MenuItem key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </MenuItem>
              ))}
            </SubMenu>
            {/* End Portfolio SubMenu */}

            <SubMenu title="Company">
              {Company.map((val, i) => (
                <MenuItem key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </MenuItem>
              ))}
            </SubMenu>
            <SubMenu title="Contact Us" > 
    {/* WhatsApp */}
    <MenuItem>
      <a
        href="https://api.whatsapp.com/send?phone=919884036062"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
         
         
        }}
      >
        <FaWhatsapp className="fs-3" style={{ color: "#f18f27" }} />
        <span style={{
       
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}>WhatsApp</span>
      </a>
    </MenuItem>

    {/* Call submenu */}
    
    <SubMenu
  title={
    <span
      style={{
       
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <FaEnvelope className="fs-3" style={{ color: "#f18f27" }} />
      Email Us
    </span>
  }
>
  <MenuItem>
    <a href="mailto:Info@Raiden.Studio">Info@Raiden.Studio</a>
  </MenuItem>
 
</SubMenu>
<SubMenu
  title={
    <span
      style={{
       
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      < FaMapMarkerAlt className="fs-3" style={{ color: "#f18f27" }} />
      Address
    </span>
  }
>
  <MenuItem>
    <p>Raiden Studios,
      <p>Peelamedu,</p>Coimbatore</p>
  </MenuItem>
 
</SubMenu>
 
  </SubMenu>

            {/* End Docs SubMenu */}

            {/* <MenuItem>
              <Link to="/login">Login</Link>
            </MenuItem> */}
          </Menu>
        </SidebarContent>
        {/* <SidebarFooter>
          <img src={whatsapp} alt="" />
        </SidebarFooter> */}
      </ProSidebar>
    </div>
  );
};

export default MegaMenuMobile;
